export default {
  list: {
    headers: {
      id: "ID",
      name: "Company Name",
      accredible: "Accredible",
      manualCertificate: "Manual Certificate",
      employeesCount: "Employees Count",
      maxEmployees: "Employees Limit",
      pathsCount: "Paths Count",
    },
    tooltips: {
      employeeAdd: "Add Employee",
      employeesList: "Employees List",
    },
  },
  form: {
    buttons: {
      send: "Add Company",
      save: "Save Changes",
    },
    files: {
      privacyFile: "privacy policy",
      tosFile: "terms of service",
    },
    headers: {
      info: "Information",
      settingsPaths: "Career Paths Settings",
      settingsExams: "Exams Settings",
      seriesVisibility: "Series exclusions",
    },
    labels: {
      name: "Company Name",
      rpgUrl: "RPG URL",
      maxEmployees: "Employees Limit",
      pathsWarning: "Paths Warning",
      unjoinable: "Visible paths without join option",
      isOnboarding: "Onboarding",
      souEnabled: "SOU",
      pathsPage: "Access to paths page",
      isPrivacyPolicy: "Privacy Policy",
      userPathNext:
        "After completing a path, allow automatic transition to the next one",
      userPathNextHelp: "If one has been added.",
      tos: "Additional Terms of Service",
      accredible: "Accredible",
      manualCertificate: "Manual Certificate",
      cohort: "Cohort Module",
      isTest: "Test Company",
      newUI: "New UI",
      rpgSkillsEnabled: "RPG",
      rpgAiCollaborationEnabled: "AI Collaboration (requires RPG)",
      rpgLimit: "RPG limit",
      rpgLimitPlaceholder: "No limit",
      rpgAiBudget: "Monthly RPG AI budget ($)",
      rpgAiBudgetPlaceholder: "No limit",
      rpgAiBudgetHint: "Once the amount is reached in a month, employees cannot start a new exercise.",
      seriesHideMode: "Series exclusion mode",
      seriesHideExcludeOnly: "Exclude only selected series",
      seriesHideExcludeAllExcept: "Exclude all except selected series",
      seriesHideHiddenSeries: "Series to exclude",
      seriesHideVisibleSeries: "Series that should stay visible",
    },
  },
};
